import styled, {css} from 'styled-components'

export const StyledInvitationStatusIcon = styled.span<{$hasAcceptedInvitation: boolean}>(
    ({theme: {palette}, $hasAcceptedInvitation}) => css`
        display: flex;
        align-items: center;
        flex-shrink: 0;
        color: ${$hasAcceptedInvitation ? palette.primary['600'] : palette.neutral['400']};
    `
)
